import novaClient from "./client";
import type { AccessRightRow, AccessValue, AppRole } from "../../constants/accessRights";

export interface AuthorizationCapabilitiesResponse {
  userId: string;
  email: string;
  role: AppRole;
  permissions: Partial<Record<AccessRightRow["id"], AccessValue>>;
}

export async function getAuthorizationCapabilities(): Promise<AuthorizationCapabilitiesResponse> {
  const res = await novaClient.get<AuthorizationCapabilitiesResponse>("/me/authorization");
  return res.data;
}